import React, { useState, useEffect } from 'react'

/*
  Usage:
  <TableFilters
    filters={[
      { key:'search', label:'Search', type:'text', fields:['client_name','project_name'] },
      { key:'stage', label:'Stage', type:'select', options:['In Progress','Review','Completed'] },
      { key:'payment_status', label:'Payment', type:'select', options:['Pending','Received','Overdue'] },
    ]}
    data={projects}
    onFiltered={setFilteredProjects}
  />
*/

export default function TableFilters({ filters, data, onFiltered }) {
  const [values, setValues] = useState({})

  useEffect(() => {
    let result = data
    filters.forEach(f => {
      const val = values[f.key]
      if (!val) return
      if (f.type === 'text') {
        const q = val.toLowerCase()
        const fields = f.fields || [f.key]
        result = result.filter(row =>
          fields.some(field => (String(row[field] || '')).toLowerCase().includes(q))
        )
      } else if (f.type === 'select' && val !== '') {
        result = result.filter(row => row[f.key] === val)
      }
    })
    onFiltered(result)
  }, [values, data, filters, onFiltered])

  function updateFilter(key, val) {
    setValues(prev => ({ ...prev, [key]: val }))
  }

  function clearAll() { setValues({}) }

  const hasActive = Object.values(values).some(v => v)

  return (
    <div className="filter-bar">
      {filters.map(f => {
        if (f.type === 'text') {
          return (
            <input
              key={f.key}
              className="filter-input"
              placeholder={f.label + '…'}
              value={values[f.key] || ''}
              onChange={e => updateFilter(f.key, e.target.value)}
            />
          )
        }
        if (f.type === 'select') {
          return (
            <select
              key={f.key}
              className="filter-select"
              value={values[f.key] || ''}
              onChange={e => updateFilter(f.key, e.target.value)}
            >
              <option value="">{f.label}: All</option>
              {f.options.map(o => <option key={o} value={o}>{o}</option>)}
            </select>
          )
        }
        return null
      })}
      {hasActive && (
        <button className="btn" style={{ padding:'4px 10px', fontSize:11 }} onClick={clearAll}>Clear</button>
      )}
    </div>
  )
}
